import React, {Component} from 'react';
import "./Spacer.css"
import "./commonAnalysisStyle.css"


class Spacer extends Component {
    render() {
        return (
            <div id="spacer" className="spacerSpace commonAnalysisFeatures"/>
        )
    }
}

export default Spacer;


// WEBPACK FOOTER //
// ./src/components/Spacer.jsx